import React, { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../components/header_logged'
import Footer from '../../../components/footer'
import Head from '../../../components/head';
import TransferenciasEstado from '../../../components/auth/transferenciasestado'

function transferenciasEstadoScreen() {
        return (
            <Fragment>
                <Head titulo="Módulo de Transferência de Recursos Estaduais" />
                <HeaderLogged />
                <Container>
                   <TransferenciasEstado />
                </Container>
                <Footer />
            </Fragment>
        );
}

export default transferenciasEstadoScreen;